import React from 'react'
import { useSearchParams } from 'react-router-dom'
import OpStageManager from '../../../ProductionFlow/OpStageManager'

interface ShowServicesProps {
  setModalActive?: React.Dispatch<React.SetStateAction<number | null>>
  refresh?: boolean
  setRefresh?: React.Dispatch<React.SetStateAction<boolean>>
  setServiceToEdit?: React.Dispatch<React.SetStateAction<any>>
  opIdProps?: number
}

const ShowServices: React.FC<ShowServicesProps> = ({ opIdProps }) => {
  const [searchParams] = useSearchParams()
  const opId = opIdProps ?? Number(searchParams.get('id'))

  if (!opId) return null

  return <OpStageManager opId={opId} />
}

export default ShowServices
